import { Record } from 'immutable';

export const ItemModel = Record({
  value: '',
  label: '',
});

export const itemToString = item => item && item.label;
